import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-programari-results',
  templateUrl: './programari-results.component.html',
  styleUrls: ['./programari-results.component.scss']
})
export class ProgramariResultsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
